import { useContextState } from "../../../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()

  const sharedStyles = {
    squareButton: {
      color: colors.color5,
      borderRadius: '50%',
      boxShadow: `1px 1px 2px ${colors.color10}`,
      padding: '12px',
      maxHeight: '45px',
      maxWidth: '45px',
      background: colors.color30,
      '&:hover': {
        background: colors.color30 + 'dd',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.7rem',
      },
      marginRight: '-5px'
      //marginBottom: '2px',
    },
    flexBasic: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    errorAmount: {
      fontSize: '11px',
      color: colors.color19,
    },
  }

  const getColor = (status: number) => {
    let color;

    switch (status) {
      case 2:
        color = colors.color1
        break;
      case 3:
        color = colors.color12
        break;
      case 4:
        color = colors.color8
        break;
      case 5:
        color = colors.color20
        break;
    }

    return color;
  }

  return {
    userContainer: {
      padding: 3,
    },
    header: (flag: boolean) => ({
      display: flag ? 'flex' : 'block',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& .dspAndGp': {
        display: 'flex',
        gap: 2
      }
    }),
    headerAndIcon: (status: number) => ({
      display: 'flex',
      gap: 1,
      alignItems: 'center',
      '& .MuiSvgIcon-root': {
        color: getColor(status)
      }
    }),
    title: (status: number) => ({
      color: getColor(status),
      fontWeight: 'bold'
    }),
    description: {
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      marginTop: 1,
      marginBottom: 1
    },
    badge: {
      marginRight: '10px',
      '& .MuiBadge-badge': {
        background: colors.color20,
        color: colors.color25,
      },
    },
    clip: {
      ...sharedStyles.squareButton,
    },
    buttonsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
      gap: 1
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '90vh',
    },
    bodyContainer: {
      flex: 1,
      overflow: 'auto',
      scrollbarWidth: 'none',
      padding: '0px 2px'
    },
  }
}

export { useStyles }
